export default __webpack_public_path__ + "media/images/Masto-D2-LaDouche-b3d3130d6055d66f7b5afe4af713d465.png";